/** Shown while the portal is still rendering a log's layouts. */
export function ProcessingNotice() {
  return (
    <div className="processing" role="status">
      <p>The Log you have selected for viewing is still in the process of generating all layouts.</p>
      <p>This process could take up to a few minutes to complete.</p>
      <h3>Processing…</h3>
      <span className="processing-spinner" aria-hidden="true" />
    </div>
  );
}
